module.exports = __webpack_public_path__ + "img/arrow_btn.25de000f.png";